var _defs, _rect, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeWebsite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    width: 800,
    height: 450,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "websiteBg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#054f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098bcc"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    fill: "url(#websiteBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.07
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 70,
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 700,
    cy: 400,
    r: 120
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400 225)",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 105
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-105 0 h210"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -105 v210",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 0,
    rx: 45,
    ry: 105
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88 -52 A 150 150 0 0 1 88 -52",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-88 52 A 150 150 0 0 0 88 52",
    opacity: 0.55
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWebsite);
export default __webpack_public_path__ + "static/media/home-website.aa8aaa59c0b0709707f5bef3f1173143.svg";
export { ForwardRef as ReactComponent };